{
	"selectAll": "Select all"
}
